import { Tooltip } from "@mui/material"
import NumberFormat from "react-number-format"

export const renderUserPayed = (params) => {
if(!params.row.userData) return 'سیستمی'
  return params.row.userData?.firstName
}
export const renderUserPayedMobile = (params) => {
  if(!params.row.userData) return 'ندارد'
  return params.row.userData?.phoneNumber
}

export const columnsGrid = t => [

  {
    field: "amount",
    headerName: "مبلغ (ریال)",
    renderCell: ({ row }) => {
      return (
        <NumberFormat
          displayType={"text"}
          value={row.amount}
          thousandSeparator={true}
        />
      )
    },
  },
  {
    field: "gatewayTypeName",
    headerName: "درگاه",
    valueGetter: params => `${t("accounting." + params.row.gatewayTypeName)}`,
  },
  {
    field: "transactionStatusName",
    headerName: "واریز/برداشت",
    renderCell: ({ row }) => { return <Tooltip title={row.bankTransactionId} placement='left'>
    <div style={{backgroundColor: row.transactionStatus == 1?'skyblue':'red', color: 'white', padding: '2px 5px', borderRadius: '5px'}}>{t("accounting." + row.transactionStatusName)}</div>
      </Tooltip>},
  },
  {
    field: "bankTransactionId",
    headerName: "شماره پیگیری",
    renderCell: ({ row }) => { return <Tooltip title={row.bankTransactionId} placement='left'>
      <div>{ row.bankTransactionId.slice(0, 30) }</div>
        </Tooltip>},
    width:"200"
  },
  {
    field: "des",
    headerName: "توضیحات",
    renderCell: ({ row }) => { return <Tooltip title={row.des} placement='left'>
      <div>{  row.des }</div>
        </Tooltip>},
    width:"300"
  },
  {
    field: "solarCreated",
    headerName: "تاریخ",
    renderCell: ({ row }) => row.solarCreated.substr(0,10)
  }
]

export const columnsClientGrid = t => [

  {
    field: "amount",
    headerName: "مبلغ (ریال)",
    width: 130,
    renderCell: ({ row }) => {
      return (
        <NumberFormat
          displayType={"text"}
          value={row.amount}
          thousandSeparator={true}
        />
      )
    },
  },
  {
    field: "bankTransactionId",
    headerName: "شماره پیگیری",
    width: 190,
  },
  {
    field: "gatewayTypeName",
    headerName: "درگاه",
    valueGetter: params => `${t("accounting." + params.row.gatewayTypeName)}`,
    width: 90,
  },
  {
    field: "transactionStatusName",
    headerName: "واریز/برداشت",
    valueGetter: params =>
      `${t("accounting." + params.row.transactionStatusName)}`,
  },
  {
    field: "userPayed",
    headerName: "ذی نفع",
    renderCell: params => renderUserPayed(params),
    width: 120,
  },
  {
    field: "userPayedMobile",
    headerName: "شماره موبایل",
    renderCell: params => renderUserPayedMobile(params),
    width: 100,
  },
  {
    field: "fileNumber",
    headerName: "مربوط به پرونده",
    width: 120,
  },
  {
    field: "des",
    headerName: "توضیحات",
    renderCell: ({ row }) => { return <Tooltip title={row.des} placement='left'>
    <div>{  row.des ? row.des.slice(0, 40) + '...' : ' -- ' }</div>
      </Tooltip>},
    width: 250,
  },
  {
    field: "solarCreated",
    headerName: "تاریخ",
    renderCell: ({ row }) => row.solarCreated.substr(0,10),
    width: 160,
  },
]


export const columnsEngGrid = t => [
  {
    field: "sumAmountWithFish",
    headerName: "خالص واریزی",
    renderCell: ({ row }) => {
      return (
        <NumberFormat
          displayType={"text"}
          value={row.engPaymentList?.sumAmountWithFish?row.engPaymentList.sumAmountWithFish:''}
          thousandSeparator={true}
        />
      )
    },
  },
  {
    field: "deduction2",
    headerName: "کسورات بیمه",
    renderCell: ({ row }) => {
      return (
        <NumberFormat
          displayType={"text"}
          value={row.engPaymentList?.deduction2?row.engPaymentList.deduction2:''}
          thousandSeparator={true}
        />
      )
    },
  },
  {
    field: "deduction1",
    headerName: "کسورات",
    renderCell: ({ row }) => {
      return (
        <NumberFormat
          displayType={"text"}
          value={row.engPaymentList?.deduction1?row.engPaymentList.deduction1:''}
          thousandSeparator={true}
        />
      )
    },
  },
  {
    field: "addition1",
    headerName: "اضافات",
    renderCell: ({ row }) => {
      return (
        <NumberFormat
          displayType={"text"}
          value={row.engPaymentList?.addition1?row.engPaymentList.addition1:''}
          thousandSeparator={true}
        />
      )
    },
  },
  {
    field: "amount",
    headerName: "بدون کسورات",
    renderCell: ({ row }) => {
      return (
        <NumberFormat
          displayType={"text"}
          value={row.amount}
          thousandSeparator={true}
        />
      )
    },
  },
  {
    width: 40,
    field: "gatewayTypeName",
    headerName: "درگاه",
    valueGetter: params => `${t("accounting." + params.row.gatewayTypeName)}`,
  },
  {
    field: "transactionStatusName",
    headerName: "واریز/برداشت",
    valueGetter: params =>
      `${t("accounting." + params.row.transactionStatusName)}`,
  },
  {
    width: 80,
    field: "bankTransactionId",
    headerName: "کد پیگیری",
    renderCell: ({ row }) => { return <Tooltip title={row.bankTransactionId} placement='left'>
      <div>{  row.bankTransactionId ? row.bankTransactionId.slice(0, 10) + '...' : ' -- ' }</div>
        </Tooltip>},
  },
  {
    width: '350',
    field: "des",
    headerName: "توضیحات",
    renderCell: ({ row }) => { row.des},
  }
]